/**
 * whatwg-fetch - That is needed her for now.
 * Maybe we can remove it, when can change the order fatlind of the scripts
 */
import 'whatwg-fetch';
import {App} from 'Container/App';
import './style.scss';

// FF history back fix
window.onunload = () => {};
App();
